import type { LongevityDayPackage } from '../../features/execute/api';

const CACHE_TTL_MS = 5 * 60 * 1000;

interface CacheEntry<T> {
  data: T;
  ts: number;
}

let homeCache: CacheEntry<LongevityDayPackage | null> | null = null;
const dayCache = new Map<number, CacheEntry<LongevityDayPackage>>();

function isFresh<T>(entry: CacheEntry<T> | null | undefined): entry is CacheEntry<T> {
  if (!entry) return false;
  return Date.now() - entry.ts < CACHE_TTL_MS;
}

export function getCachedLongevityHome(): LongevityDayPackage | null | undefined {
  if (!isFresh(homeCache)) return undefined;
  return homeCache.data;
}

export function setCachedLongevityHome(dayPackage: LongevityDayPackage | null) {
  homeCache = { data: dayPackage, ts: Date.now() };
  if (dayPackage) setCachedLongevityDay(dayPackage);
}

export function getCachedLongevityDay(day: number): LongevityDayPackage | null {
  const cached = dayCache.get(day);
  if (!isFresh(cached)) return null;
  return cached.data;
}

export function setCachedLongevityDay(dayPackage: LongevityDayPackage) {
  dayCache.set(dayPackage.dayNumber, { data: dayPackage, ts: Date.now() });
}
